import { GAME_ID, REDUX_ACTIONS, CHARACTERS_PER_LEVEL, SCREENS } from 'a/silabalonLaCopa/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { getLevelCurriculum, getLevelCount } from '../selectors/curriculum';

const initialState = {
  players: [],
  balls: [],
  maxPlayersPerLevel: 3,
  level: 0,
  progress: 0,
  correctCount: 0,
  hasSeenOnboarding: false,
  hasSeenPracticeOnboarding: false,
  currentScreen: SCREENS.LOADING,
  levelToHighlight: 0,
  levelCount: 0,
};

export default (state = initialState, { gameId, type, payload, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INIT_CURRICULUM:
      return {
        ...state,
        levelCount: getLevelCount(),
      };
    // update state when gamestate data has been received
    case REDUX_ACTIONS.LOAD_CURRICULUM:
      return {
        ...state,
        ...getLevelCurriculum(payload),
        levelCount: getLevelCount(),
        // levels 0 - 2 only show 1 player. Other levels show 3
        maxPlayersPerLevel: payload > 2 ? 3 : 1,
      };

      // update state when gamestate data has been received
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
      return {
        ...state,
        ...(stateData[GAME_ID].GameData || {}),
      };

    case REDUX_ACTIONS.INCREASE_PROGRESS:
      return {
        ...state,
        progress: state.progress + 1,
      };

    case REDUX_ACTIONS.INCREMENT_CORRECT_COUNT:
      return {
        ...state,
        correctCount: state.correctCount + 1,
      };

    case REDUX_ACTIONS.START_ROUND:
      return {
        ...state,
        level: payload,
        progress: 0,
        correctCount: 0,
        levelToHighlight: payload,
      };

    case REDUX_ACTIONS.MARK_ONBOARDING_SEEN:
      return {
        ...state,
        hasSeenOnboarding: true,
      };

    case REDUX_ACTIONS.MARK_PRACTICE_ONBOARDING_SEEN:
      return {
        ...state,
        hasSeenPracticeOnboarding: true,
      };

    case REDUX_ACTIONS.QUICK_ROUND: {
      const numCorrect = payload ? CHARACTERS_PER_LEVEL : 0;
      return {
        ...state,
        progress: CHARACTERS_PER_LEVEL,
        correctCount: numCorrect,
      };
    }

    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: payload,
      };

    // Return to Progress Screen when gamestate call has been resolved
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...state,
        currentScreen: SCREENS.PROGRESS,
      };

    // Show Loading screen when gamestate request goes out
    case persistStateTypes.REQUEST_GAMESTATE:
      return {
        ...state,
        currentScreen: SCREENS.LOADING,
      };

    case REDUX_ACTIONS.COMPLETE_ROUND:
      return {
        ...state,
        levelToHighlight: state.levelToHighlight + 1,
      };

    default:
      return state;
  }
};
